<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="formatedDate"
        clearable
        :label="label"
        :hint="hint"
        persistent-hint
        prepend-icon="event"
        readonly
        v-on="on"
        @input="clear"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      no-title
      @input="inputChange"
      :first-day-of-week="firstDayOfWeek($i18n.locale)"
      :locale="$i18n.locale"
    ></v-date-picker>
  </v-menu>
</template>

<script>
import { firstDayOfWeek } from '@/script/dateAndHour'
import { mapState } from 'vuex'

export default {
  name: 'Datepicker',

  props: {
    label: {
      type: String,
      default: ''
    },
    path: {
      type: String,
      default: ''
    }
  },
  data: () => ({
    date: '',
    menu: false,
    hint: ''
  }),

  created() {
    const previousDate = this.$store.state.researchShooting.current[this.path]

    if (!previousDate) return

    this.date = previousDate
  },

  computed: {
    ...mapState({
      startDate: state => state.researchShooting.current.startDate,
      endDate: state => state.researchShooting.current.endDate
    }),
    formatedDate: {
      get() {
        const date = this[this.path]

        return this.formatDate(date)
      },
      set(val) {
        let commitName
        this.path === 'startDate' ? (commitName = 'RESEARCH_STARTDATE') : (commitName = 'RESEARCH_ENDDATE')
        !val && this.$store.commit(commitName, val)
      }
    }
  },

  methods: {
    clear() {
      this.date = null
    },
    inputChange() {
      let commitName
      this.menu = false
      this.path === 'startDate' ? (commitName = 'RESEARCH_STARTDATE') : (commitName = 'RESEARCH_ENDDATE')

      this.$store.commit(commitName, this.date)
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    firstDayOfWeek(locale) {
      return firstDayOfWeek(locale)
    }
  }
}
</script>
